import { Link, useParams } from "react-router-dom";
import { useStores } from "../hooks/useApi";
import { StoreCount } from "./StoreCount";

interface Store {
  id: string;
  code: string;
  name: string;
}

export function AdminStoreDay() {
  const { storeId } = useParams<{ storeId: string }>();
  const { data: stores } = useStores();

  if (!storeId) return <div style={{ padding: "1rem" }}>Store not found.</div>;

  const store = ((stores as Store[]) || []).find((s) => s.id === storeId);

  return (
    <div>
      <div className="subpage-bar">
        <Link to="/admin/overview" className="subpage-back-link">
          ← Overview
        </Link>
        <strong className="subpage-title">
          {store ? `${store.code} — ${store.name}` : "Store"}
        </strong>
        <span className="subpage-caption">
          (editing as admin)
        </span>
      </div>
      <StoreCount storeId={storeId} />
    </div>
  );
}
